export const container = `w-full flex flex-col gap-y-1`;
export const item = `h-6 bg-gray-150 rounded animate-pulse`;
